import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {accidentInjuriesPath} from './PropertyPaths/accidentInjuriesPath';

export const BurnSkinGraft = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentInjuriesPath(selectedPlan?.planIndex || 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'burn-skin-graft-row-1'},
      items: [
        {
          key: propertyPaths.burnSkinGraftDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.burnSkinGraftDetails.incurralPeriod)}
              disabled
              id={propertyPaths.burnSkinGraftDetails.incurralPeriod}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.burnSkinGraftDetails.burnsBenefitPct,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Benefit Amount (% of Burns Benefit)"
              searchKey={`ACCBurnSkinGraftBenefit.burnsBenefitPct`}
              value={getQuoteFieldValue<number>(propertyPaths.burnSkinGraftDetails.burnsBenefitPct)}
              disabled
              id={propertyPaths.burnSkinGraftDetails.burnsBenefitPct}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'burn-skin-graft-row-2'},
      items: [
        {
          key: propertyPaths.burnSkinGraftDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`ACCBurnSkinGraftBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(propertyPaths.burnSkinGraftDetails.maxBenefitNumber)}
              disabled
              id={propertyPaths.burnSkinGraftDetails.maxBenefitNumber}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.burnSkinGraftDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={`ACCBurnSkinGraftBenefit.timePeriodCd`}
              label="Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.burnSkinGraftDetails.timePeriodCd)}
              disabled
              required
              id={propertyPaths.burnSkinGraftDetails.timePeriodCd}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
